var _rect, _path, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropose2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 34,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3344 51.7101L43.992 61.3813C41.7398 62.5074 39.0888 62.5074 36.8366 61.3813L24.3702 55.1481M63.3344 51.7101V33.7342C63.3344 30.704 61.6224 27.9339 58.9121 26.5788L43.992 19.1187C41.7398 17.9926 39.0888 17.9926 36.8366 19.1187L21.9164 26.5788C19.2062 27.9339 17.4941 30.704 17.4941 33.7342V46.7658C17.4941 49.796 19.2062 52.5661 21.9164 53.9212L24.3702 55.1481M63.3344 51.7101L51.1847 44.7674C48.7656 43.385 45.8015 43.3609 43.3602 44.7036L24.3702 55.1481",
    stroke: "url(#paint0_linear_3061_13262)",
    strokeWidth: 4.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5381,
    cy: 33.374,
    r: 4.58403,
    stroke: "url(#paint1_linear_3061_13262)",
    strokeWidth: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 8,
    r: 8,
    fill: "#D50101"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3061_13262",
    x1: 40.4143,
    y1: 17.3299,
    x2: 40.4143,
    y2: 63.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3061_13262",
    x1: 33.5381,
    y1: 16.4355,
    x2: 33.5381,
    y2: 63.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59331"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropose2);
export default __webpack_public_path__ + "static/media/propose2.c59bd1ab625f98a0cf7e5a7d17e27946.svg";
export { ForwardRef as ReactComponent };